import styled from "styled-components";
import { theme } from "../theme";

export const StyledStatus = styled.span`
	display: inline-block;
	width: 1.4rem;
	height: 1.4rem;
	border-radius: 50%;
	flex-shrink: 0;
	margin: 1rem;

	background: ${({ status }) => {
		if (status === "done") {
			return theme.color.green;
		} else if (status === "ongoing") {
			return theme.color.orange;
		}
	}};
`;
